import { defineComponent as _defineComponent } from 'vue'
import { inject, ref, watch } from "vue"
import { notification } from 'ant-design-vue';
import k2Tooltip from '@/components/tooltip/k2-tooltip.vue';
import type { TranslationServiceType } from '@/utils/translation.service';
import request from '@/global/request';
import { storeToRefs } from "pinia";
import { userStore } from "@/store/modules/user";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import util from "@/utils/util";
import { pinyin as pinyinPro } from 'pinyin-pro';

// 路由管理实例化

export default /*#__PURE__*/_defineComponent({
  __name: 'siderbar',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();
const store = userStore();
const { locale } = useI18n();

// index.html 路径（兼容微前端）
const indexHtmlPath = (window as any).__POWERED_BY_QIANKUN__ ? '/micro-app/process-portal/index.html' : '/index.html';

// 获取登录人信息
const { employeeId } = storeToRefs(store);
let translationService = inject('translationService')

let activate = ref('data-task-management');
const key = ref(`open${Date.now()}`);
const showUserDesc = ref(false);
const showSelect = ref(false);
const accountData = ref<any>({})
let defaultHead = ref('');
/** 多语言切换 代码实例 begin */
let language = ref(localStorage.getItem('PAI-language') || 'zh_CN')
// 设置菜单选中：index.html 时按 cls 参数（无 cls 时默认任务列表），否则按 route.name
watch(() => router.currentRoute.value,(val: any) => {
  if (!val) return;
  const isIndexHtml = val.path === '/index.html' || val.path?.endsWith('/index.html');
  if (isIndexHtml) {
    // 有 cls 用 cls，无 cls 时默认显示任务列表，菜单也对应选中
    activate.value = val.query?.cls || 'data-task-management';
  } else if (val.meta?.siderbar && val.name) {
    activate.value = val.name;
  }
},{ immediate: true });

const changeLang = (): void => {
  showUserDesc.value = true;
  (translationService as TranslationServiceType).refreshTranslation(language.value);
  let lang = language.value
  if (lang === 'zh_CN' || lang === 'zh_TW') {
    lang = lang.replace('_', '-');
  }
  locale.value = lang;
  location.reload()
}
function unshowUser() {
  showUserDesc.value = false;
  showSelect.value = false;
}

/**
* 获取 人员默认头像
* @description:
* @param {type}
* @return:
*/
function getDefaultHead(){
  request({
    method: 'post',
    url: 'object/api/last/nebulogyConfigObj/page',
    data: {},
  }).then((res:any)=>{
    defaultHead.value = '';
    if(res.responseCode === '100') {
      if(res.nebulogyConfigObjList.length > 0) {
        let result = res.nebulogyConfigObjList[0];
        defaultHead.value = result.defaultHead;
      }
    }
  }).catch((err:any) => {
    throw err;
  });
}

/**
 * 获取个人信息
 */
const getListData = () => {
  request({
    url: `center-portal/api/centerEmployee/query/${employeeId.value}`,
    method: 'get',
  }).then((res: any) => {
    if(res){
      accountData.value = res;
    }
  }).catch((err) => {
    throw err;
  });
}
/**
 * 退出登录
 */
const accountExit = () => {
  notification.close(key.value);
  localStorage.removeItem('PAI-token');
  localStorage.removeItem('PAI-account');
  localStorage.removeItem('Login-time');
  if ((window as any).serverConfig.IS_MULTI_TENANCY) {
    let tenantName = localStorage.getItem('tenantName');
    router.push({ name: 'login',query: {tenantName: tenantName} })
  } else {
    router.push({ name: 'login' })
  }
}
/**
 * @FunctionName: 跳转管理后台
 * @param {*}
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2023-11-24 13:59:56
 * @Description: 
 */
function backManagement(){
  location.href = location.origin;
}

/**
 * @FunctionName: 设置卡片背景色
 * @param {*} name
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-01-12 10:38:34
 * @Modification history:
 * @Description:
 */
function getBackgroundColorByLastName() {
  let name = accountData.value.lastName || accountData.value.firstSpell || accountData.value.pinyin;
  if(name){
    name = pinyinPro(name);
  }
  return util.getBackgroundColorByLastName(name);
}

/**
 * @FunctionName: 设置卡片背景图片
 * @param {*} name
 * @return {*}
 * @Author: zhuzhaoyang
 * @Date: 2021-01-12 10:38:34
 * @Modification history:
 * @Description:
 */
function getBackgroundPictureByLastName() {
  let name = accountData.value.lastName || accountData.value.firstSpell || accountData.value.pinyin;
  let sex = accountData.value.gender == '2' ? 'woman' : 'man';
  if(name){
    name = pinyinPro(name);
  }
  return util.getBackgroundPictureByLastName(name,sex);
}

const __returned__ = { router, store, locale, indexHtmlPath, employeeId, get translationService() { return translationService }, set translationService(v) { translationService = v }, get activate() { return activate }, set activate(v) { activate = v }, key, showUserDesc, showSelect, accountData, get defaultHead() { return defaultHead }, set defaultHead(v) { defaultHead = v }, get language() { return language }, set language(v) { language = v }, changeLang, unshowUser, getDefaultHead, getListData, accountExit, backManagement, getBackgroundColorByLastName, getBackgroundPictureByLastName, k2Tooltip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})